type Props = { message?: string | null }

export function Toast({ message }: Props) {
  if (!message) return null
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'var(--bg-2)',
        border: '1px solid var(--border-default)',
        borderRadius: 8,
        padding: '10px 14px',
        fontSize: 13,
        color: 'var(--fg-1)',
        boxShadow: 'var(--shadow-pop)',
        zIndex: 100,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
      }}
    >
      <span
        style={{ width: 6, height: 6, borderRadius: 9999, background: 'var(--accent)' }}
      />
      {message}
    </div>
  )
}
